import r, { css as s } from "styled-components";
import { Base as l } from "./atoms-v2777.js";
import { Column as d } from "./atoms-v212.js";
import { breakpoints as a } from "./atoms-v2125.js";
import { Specs as x } from "./atoms-v239.js";
import { Grid as g } from "./atoms-v216.js";
import { Button as c } from "./atoms-v26.js";
import { Picture as e } from "./atoms-v233.js";
const t = 60, S = r(g)`
  ${l}

  color: ${({ theme: i }) => i == null ? void 0 : i.get("tokens.text.light.secondary")};
  padding-block: 20px;
  position: relative;

  ${({ theme: i }) => {
  const o = i == null ? void 0 : i.get("tokens.breakpoints.large.margin"), n = i == null ? void 0 : i.get("tokens.breakpoints.xLarge.margin"), p = i == null ? void 0 : i.get("tokens.breakpoints.max.margin");
  return s`
      @media ${a.large} {
        margin-left: -${o}px;
        margin-right: -${o}px;
        overflow-x: hidden; /* ContentHeaderBackground would overflow otherwise */
        padding: ${t}px ${o}px 0 ${o}px;
        width: calc(100% + ${2 * o}px);
      }

      @media ${a.xLarge} {
        margin-left: -${n}px;
        margin-right: -${n}px;
        padding-left: ${n}px;
        padding-right: ${n}px;
        width: calc(100% + ${2 * n}px);
      }

      @media ${a.max} {
        margin-left: -${p}px;
        margin-right: -${p}px;
        padding-left: ${p}px;
        padding-right: ${p}px;
        width: calc(100% + ${2 * p}px);
      }
    `;
}}

  @media ${a.medium} {
    padding-block: 40px;
  }
`, w = r(d)`
  container-type: inline-size;
  display: flex;
  flex-direction: column;
  gap: 20px;

  @media ${a.medium} {
    gap: 24px;
  }

  @media ${a.large} {
    gap: 0;
  }
`, C = r(e)`
  border-radius: ${({ theme: i }) => `${i == null ? void 0 : i.get("tokens.radius.cardRadiusSm")}px`};

  @media ${a.medium} {
    border-radius: ${({ theme: i }) => `${i == null ? void 0 : i.get("tokens.radius.cardRadiusMed")}px`};
  }
`, L = r.div`
  @media ${a.large} {
    display: none;
  }
`, J = r.div`
  display: flex;
  flex-direction: column;
  gap: 10px;

  @media ${a.medium} {
    gap: 16px;
  }

  @media ${a.large} {
    gap: 12px;
    padding-bottom: ${t}px;
    position: relative;
  }

  @media ${a.xLarge} {
    gap: 24px;
  }

  @media ${a.max} {
    padding-bottom: 100px;
  }
`, M = r.div`
  background-color: ${({ theme: i }) => i == null ? void 0 : i.get("tokens.surface.light.layer01")};
  height: calc(100% + ${t}px);
  left: -999999px;
  position: absolute;
  right: -999999px;
  top: -${t}px;
  z-index: -1;
`, B = r.div`
  ${({ theme: i }) => {
  var o;
  return (o = i == null ? void 0 : i.get("tokens.helper.xs-productive")) == null ? void 0 : o.toJS();
}}

  color: ${({ theme: i }) => i == null ? void 0 : i.get("tokens.text.light.primary")};
  text-transform: uppercase;

  @media ${a.medium} {
    ${({ theme: i }) => {
  var o;
  return (o = i == null ? void 0 : i.get("tokens.helper.productive")) == null ? void 0 : o.toJS();
}}
  }

  @media ${a.xLarge} {
    ${({ theme: i }) => {
  var o;
  return (o = i == null ? void 0 : i.get("tokens.helper.expressive")) == null ? void 0 : o.toJS();
}}
  }
`, P = r.div`
  ${({ theme: i }) => {
  var o;
  return (o = i == null ? void 0 : i.get("tokens.body.expressive")) == null ? void 0 : o.toJS();
}}

  color: ${({ theme: i }) => i == null ? void 0 : i.get("tokens.text.light.primary")};

  @media ${a.xLarge} {
    ${({ theme: i }) => {
  var o;
  return (o = i == null ? void 0 : i.get("tokens.heading.04")) == null ? void 0 : o.toJS();
}}
  }
`, R = r.div`
  ${({ theme: i }) => {
  var o;
  return (o = i == null ? void 0 : i.get("tokens.body.compact-productive")) == null ? void 0 : o.toJS();
}}

  display: flex;
  flex-direction: column;
  gap: 12px;

  @media ${a.large} {
    gap: 16px;
  }

  @media ${a.xLarge} {
    ${({ theme: i }) => {
  var o;
  return (o = i == null ? void 0 : i.get("tokens.body.compact-expressive")) == null ? void 0 : o.toJS();
}}
  }
`, H = r(c)`
  width: 100%;

  @media ${a.medium} {
    width: 220px;
  }

  @media ${a.large} {
    margin-top: 40px;
  }
`;
r(g)`
  display: none;
  left: 0;
  position: absolute;
  top: 0;

  @media ${a.large} {
    display: flex;
  }
`;
const z = r(x)`
  color: ${({ theme: i }) => i == null ? void 0 : i.get("tokens.text.light.primary")};
  gap: 8px;
  justify-content: flex-start;

  @media ${a.medium} {
    gap: 16px;
  }

  @media ${a.large} {
    align-items: flex-start;
    flex-direction: column;
    gap: 10px;
  }
`, A = r(d)`
  align-items: flex-start;
  display: flex;
  gap: 8px;

  & picture:nth-child(1) {
    flex-grow: 1;
  }

  & picture:nth-child(2) {
    flex-basis: 37%;
    flex-shrink: 0;
  }
`;
export {
  w as Content,
  R as ContentArea,
  H as ContentButton,
  J as ContentHeader,
  M as ContentHeaderBackground,
  C as ContentPicture,
  B as ContentSubtitle,
  P as ContentTitle,
  L as MobilePictureWrapper,
  z as SpecList,
  S as UpgradeRoom,
  A as V2Pictures
};
